<!--Footer Starts-->
<footer>
    <div *ngIf="showCR" class="container-fluid">
        <p class="copyright text-center">
            V.{{version}}    Copyright  &copy;  {{currentDate | date: 'yyyy'}} <a id="qseveilleLink" href="https://www.qse-veille.fr">QSE Veille</a>, Tous droits réservés.          
        </p>
        
    </div>
</footer>
<!--Footer Ends-->